/**
 * Default export pour l'auto-discovery `apps/web/src/routes/modules.ts`.
 *
 * Onglet « Changements de prix » (icône lucide `trending-up`), visible à TOUT
 * compte connecté (spec Ben 02/10, décision 4 — absent de
 * `apps/web/src/lib/acces.ts` `ECRANS_RESERVES_ADMIN`). Les réglages des prix
 * (grille des formats plantes, plancher) sont une route CACHÉE atteinte depuis
 * la page (même patron que `herbo-kpi-entrepot/web/route.tsx`).
 */
import { lazy, Suspense, type ReactNode } from 'react';
import type { ModuleRoute } from '@herbo/module-route';

const ChangementsDePrix = lazy(() => import('./pages/ChangementsDePrix'));
const ReglagesPrix = lazy(() => import('./pages/ReglagesPrix'));
const PaPresta = lazy(() => import('./pages/PaPresta'));

function avecSuspense(node: ReactNode, texte: string): ReactNode {
  return <Suspense fallback={<div className="px-6 py-8 text-sm text-slate-500">{texte}</div>}>{node}</Suspense>;
}

const route: ModuleRoute = {
  path: 'changements-de-prix',
  label: 'Changements de prix',
  icon: 'trending-up',
  element: avecSuspense(<ChangementsDePrix />, 'Chargement des changements de prix…'),
};

const reglagesRoute: ModuleRoute = {
  path: 'changements-de-prix/reglages',
  label: 'Changements de prix',
  icon: 'trending-up',
  hidden: true,
  element: avecSuspense(<ReglagesPrix />, 'Chargement des réglages des prix…'),
};

/** Onglet « PA dans Presta » (spec 20/10) : route cachée, atteinte par l'onglet de la page (admin + Vir ; l'API refuse les autres). */
const paPrestaRoute: ModuleRoute = {
  path: 'changements-de-prix/pa-presta',
  label: 'Changements de prix',
  icon: 'trending-up',
  hidden: true,
  element: avecSuspense(<PaPresta />, 'Chargement des prix d’achat à mettre à jour…'),
};

export default [route, reglagesRoute, paPrestaRoute];
